import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { DspxCardSetBaseFormComponent,CoreService, DialogService, SpinnerService } from 'dspx-core';
import { Mapper, MapperBuilder, TRANSFORM } from '../../helpers/mapper';
import { Router } from '@angular/router';
import { ResponseParserService } from '../../services/response-parser.service';
import { AppDataService } from '../../services/app-data.service';
import { TEMPLATES } from '../../constants/templates.constants';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { FILTER_QUESTION_CODES, NAV_TAB_NUMBERS, PAGE_NUMBERS, QUESTION_CODES, SECTION_CODES } from '../../constants/app-data.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { ConcessionsApplicationBulkUploadGridFilterRequest } from '../../interfaces/concessions-application-bulk-upload-grid-filter-request.interface';

@Component({
  selector: 'app-concessions-application-bulk-upload-list',
  templateUrl: './concessions-application-bulk-upload-list.component.html',
  styleUrl: './concessions-application-bulk-upload-list.component.scss'
})
export class ConcessionsApplicationBulkUploadListComponent extends BaseCardSetListComponent implements OnInit {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  filterQuestionToFilterModelMapper: Mapper;
  activeDialog: string = '';

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.concessionsApplicationBulkUploadList,
      () => API_ENDPOINTS.dashboard.getConcessionsApplicationBulkUploads,
      false);

    this.filterQuestionToFilterModelMapper =
      new MapperBuilder()
        .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
        .MapFrom(FILTER_QUESTION_CODES.concessionsApplicationBulkUploadListForm.agencyFilter)
        .MapFrom(FILTER_QUESTION_CODES.concessionsApplicationBulkUploadListForm.yearFilter)
        .MapFrom(FILTER_QUESTION_CODES.concessionsApplicationBulkUploadListForm.typeFilter)
        .MapFrom(FILTER_QUESTION_CODES.concessionsApplicationBulkUploadListForm.uploadDateTimeFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.concessionsApplicationBulkUploadListForm.uploadedByFilter)
        .MapFrom(FILTER_QUESTION_CODES.concessionsApplicationBulkUploadListForm.fileStatusFilter)
        .BuildMapper();
  }

  ngOnInit(): void { }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    const applicationFilterRequest = this.getApplicationFilterRequest();
    this.loadGridData(applicationFilterRequest);
  }

  actionButton_bulkUploadPlaceholder_datagrid_custom_bulkUpload_Clicked($event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.concessionsApplicationBulkUpload.prefix]);
  }

  private getApplicationFilterRequest(): ConcessionsApplicationBulkUploadGridFilterRequest {
    const bulkUploadListFilterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.concessionsApplicationBulkUploadListForm.bulkUploads,
      PAGE_NUMBERS.concessionsApplicationBulkUploadListForm.bulkUploads,
      SECTION_CODES.concessionsApplicationBulkUploadListForm.bulkUploads,
      QUESTION_CODES.concessionsApplicationBulkUploadListForm.bulkUploadListFilter
    );

    return this.filterQuestionToFilterModelMapper.Map(bulkUploadListFilterModel);
  }

  actionButton_bulkUploadPlaceholder_datagrid_view_Clicked(event: any) {    
    this.router.navigate(['/', ROUTE_CONSTANTS.concessionsApplicationBulkUploadDetail.prefix, event.event.data.id]);
  }
}
